export enum MspExportAction {
  EXPORT_TICKETS = "exportMspTickets",
  EXPORT_DEVICES = "exportMspDevices",
  EXPORT_USERS = "exportMspUsers",
  EXPORT_USERS_AND_DEVICES_TREND = "exportUsersAndDevicesTrend",
  EXPORT_WORKSPACES_LIST = "exportWorkspacesList",
  EXPORT_WORKSPACES_SUMMARY = "exportWorkspacesSummary",
  EXPORT_ADMIN_NOTIFICATIONS = "exportAdminNotifications",
  EXPORT_TICKETS_SUMMARY = "exportMspTicketsSummary",
  EXPORT_BILLING_USAGE = "exportBillingUsage",
}
